import script from "./TimetableDates.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimetableDates.vue?vue&type=script&lang=ts&setup=true"

import "./TimetableDates.vue?vue&type=style&index=0&id=51ebe178&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3adea55ba6ae913f8a015974add4e384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ebe178"]])

export default __exports__